import { render } from "./legoCounter.vue?vue&type=template&id=4a3126e0"
import script from "./legoCounter.vue?vue&type=script&lang=js"
export * from "./legoCounter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoCounter/legoCounter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a3126e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a3126e0', __exports__)) {
    api.reload('4a3126e0', __exports__)
  }
  
  module.hot.accept("./legoCounter.vue?vue&type=template&id=4a3126e0", () => {
    api.rerender('4a3126e0', render)
  })

}


export default __exports__